export default "__VITE_ASSET__Bdm9gWGm__"